mutation CardAccountUpdate($input: CardAccountUpdateInput!) {
  cardAccountUpdate(
    input: $input
  ) {
    clientMutationId
    cardAccount {
      id
    }
  }
}
